module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "services.04fb93c3.svg";